import React from 'react';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="text-center text-xs text-gray-500 dark:text-gray-400 mt-12 mb-4">
      © {currentYear} Shenqian Wen · All rights reserved.
    </footer>
  );
}

export default Footer;